// function to prepare enums for map() in react component
const enumKeys = <T extends {}>(enumerator: T): (keyof T)[] => {
	return (Object.keys(enumerator) as (keyof T)[]).filter((val) => isNaN(Number(val)) === true);
};
export default enumKeys;

// API reponse
export enum ApiResponseEnum {
	OK,
	NO_RECORDS,
	FAIL
}
// CustomerData enums
export enum CustomerDataCustomerTypeEnum {
	Strategic = 'Strategic',
	Tender = 'Tender',
	Other = 'Other'
}
export enum CustomerDataMasterCalculationEnum {
	No,
	Yes
}
export enum CustomerDataFileFormatEnum {
	Telenor,
	TelekomSrbija
}

export enum BundleTypeEnum {
	Tariff,
	TariffHw,
	Hw,
	Profile
}

// Global Offer enums
export enum TypeOfOfferEnum {
	SME = 'SME'
}
//#region DEPRECATED
export enum OfferTypeEnum {
	HW,
	Sim
}
//#endregion
export enum CalcTypeEnum {
	SME = 0
}
export enum CalcItemStatusEnum {
	New,
	Saved,
	Changed
}
export enum OfferStateEnum {
	Open = 0,
	WaitingForApproval,
	Closed
}
export enum OfferStageEnum {
	Draft = 0,
	Prepared,
	SentToCustomer,
	Won,
	Lost,
	Canceled
}
export enum OfferStageLabelEnum {
	Draft = 'Draft',
	Prepared = 'Prepared',
	Sent = 'Sent to customer',
	Won = 'Won',
	Lost = 'Lost',
	Canceled = 'Canceled'
}

// export type { IOptionMapped } from './mappers'

//#region DEPRECATED
// export enum OfferStateEnum {
//     Open = "Open",
//     WaitingForApproval = "Waiting for approval",
//     Closed = "Closed"
// }

//#endregion
export enum OptionTypeEnum {
	Bundle = 'Bundle',
	OnTop = 'On Top'
}

export enum CalcInteractionEnum {
	Add,
	Edit,
	Copy,
	Delete,
	Up,
	Down,
	Relations
}

export enum UserRolesEnum {
	Admin = 'Admin',
	Manager = 'Manager',
	AccountManager = 'AccountManager',
	Partner = 'Partner',
	RegionalManager = 'RegionalManager',
	SalesRep = 'SalesRep',
	Configurator = 'Configurator',
	None = 'None'
}

export enum ResultTypeEnum {
	Variable,
	Formula
}

export enum OperationTypeEnum {
	Sum,
	Mult,
	Avg,
	Min,
	Max,
	Add,
	Minus,
	Times,
	Divide
}

export enum OperandTypeEnum {
	Variable,
	Parameter,
	Formula,
	Scalar
}

export enum OperandGroupEnum {
	Operand,
	Comparand,
	Comparand2
}

export enum OperationBlockEnum {
	Undefined,
	Calculus,
	Logical
}

export enum TypeVariableEnum {
	Custom,
	Predefined
}

export enum TypeVariableValueEnum {
	String,
	Number,
	Boolean
}

export enum BetweenOpEnum {
	None,
	Add,
	Minus,
	Times,
	Divide
}

export enum AggregateOpEnum {
	None = 'None',
	Sum = 'Sum',
	Mult = 'Mult',
	Avg = 'Average',
	Low = 'Low',
	Top = 'Top',
	Cnt = 'Count'
}

export enum ButtonTypesEnum {
	Save,
	Delete,
	Test,
	AddRule,
	AddFormula
}

export enum LogicalOpEnum {
	Default = 'Default',
	Equal = 'Equal',
	NotEqual = 'NotEqual',
	Greater = 'GreaterThan',
	GreaterEq = 'GreaterThanOrEqual',
	Less = 'LessThan',
	LessEq = 'LessThanOrEqual',
	Range = 'Range'
}

export enum FunctionOpEnum {
	Default = 'Default',
	Rnd = 'Round',
	Exp = 'Expand',
	Red = 'Reduce',
	Row = 'Rowget',
	Com = 'Combine',
	Min = 'Min',
	Max = 'Max'
}

export enum OperationItemsEnum {
	Operand,
	Comparator,
	Result
}

export enum OperandComparandEnum {
	Operand,
	Comparand,
	Comparand2
}
